import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { AppHelper } from '../helpers/AppHelper';
import { Status } from './Status';
import { venueMarkerData } from '../data/data';
import { vsprintf } from 'sprintf-js';
import { Helper } from '../common/helpers/Helper';
import { Grid, Tooltip } from '@material-ui/core';
import { VenueStatusTiles } from './VenueStatusTiles';
import { UiHelper } from '../common/helpers/UiHelper';
import { Fade, Slide } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
export class VenueEsperInfo extends Component {
  constructor(props) {
    super(props)
  }

  //map and places
  getMapContainer = () => {
    return (
      <div id={'map'} className={css(Styles.mapContainer)}></div>
    )
  }
  isLocationAvailable = () => {
    return (
      this.props.selectedDevice &&
      this.props.selectedDevice.es &&
      this.props.selectedDevice.es.lat &&
      this.props.selectedDevice.es.lon &&
      this.props.selectedDevice.es.lat !== 'N/A' &&
      this.props.selectedDevice.es.lon !== 'N/A'
    ) ? true : false;
  }
  loadMap = (data) => {
    const deviceLocation = {
      lat: AppConfig.DEFAULT_MAP_LOCATION.LAT,
      lng: AppConfig.DEFAULT_MAP_LOCATION.LNG,
    }
    if (this.isLocationAvailable()) {
      deviceLocation.lat = parseFloat(this.props.selectedDevice.es.lat)
      deviceLocation.lng = parseFloat(this.props.selectedDevice.es.lon)
    }
    try {
      const iconImg = require('../assets/images/map-marker.svg')
      const map = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        center: deviceLocation,
      })
      console.log(map)
      if (this.isLocationAvailable()) {
        const marker = new window.google.maps.Marker({
          position: deviceLocation,
          map,
          optimized: false,
          icon: iconImg
        });
      }
    }
    catch (err) {
      console.log('Google map load failed.', err);
    }
  }
  componentDidUpdate() {
    if (this.props.isOpen) setTimeout(() => { this.loadMap() }, 200)
  }
  onCloseModal() {
    this.props.onClosed()
  }
  render() {
    return (
      <Dialog
        open={this.props.isOpen || false}
        aria-labelledby={this.props.title}
        fullWidth={this.props.fullWidth || false}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} >
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <div className={css(Styles.mapDetailsHolder)}>
            {!this.isLocationAvailable() && <div className={css(Styles.locationNotAvailable)}>{Helper.getString('notAvailable')}</div>}
            {this.getMapContainer()}
          </div>
        </div>
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  mapDetailsHolder:{
    display: 'flex',
    width: '500px',
    height: '500px'
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#121212',
    fontSize: 28,
    maxWidth: '350px !important',
    whiteSpace: 'nowrap !important',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
    // fontWeight: 600
    '@media (max-width: 1024px)': {
      fontSize: 22,
      maxWidth: '70vw',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  modalContent: {
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  paper: {
    borderRadius: 16,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  root: {
    zIndex: 13000,
  },
  container: {
    width: '100%',
    position: 'relative'
  },
  mapContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    height: '100%',
    borderRadius: 16,
    backgroundColor: '#f5f5f5',
    '@media (max-width: 1024px)': {
      borderRadius: 20,
      height: 400
    }
  },
  locationNotAvailable: {
    position: 'absolute',
    zIndex: 999,
    fontWeight: 'bold',
    fontSize: '1.2rem',
    color: 'tomato',
    background: 'rgb(255, 255, 255)',
    borderRadius: 16,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'max-content',
    padding: '16px 14px'
  },
  mapHolder: {
    position: 'relative'
  }
})



// WEBPACK FOOTER //
// ./src/components/VenueEsperInfo.js